import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Platform, View} from 'react-native';
import FastImage from '../../Utils/FastImage';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

const SeededShuffle = require('seededshuffle');

import isIphoneX from 'src/Utils/IphoneXHelper';

/////////////////////// components
import {PrimaryButton, ImageButton, BodyText} from 'src/Modules/CommonView';

/////////////////////// utils
import {triviaCompletionEvent} from 'src/Utils/huntFunctions';
import {socialShare} from 'src/Utils/shareHelper';
import useParams from '../../Hooks/useParams';
import {navigationRef} from 'src/Nav/navigationHelpers';

const isX = isIphoneX();

const PlayerTrivia = () => {
  const {width} = useWindowDimensionsSafe();

  let {selectedChallengeId} = useParams();
  const playerChallengeData = useSelector(
    (state) => state.game?.playerChallengeData,
  );
  const groupId = useSelector((state) => state.groupInfo?.groupId);
  const characters = useSelector((state) => state.themeInfo?.characters);

  const [shuffleKey, setShuffleKey] = useState(5);

  useEffect(() => {
    setShuffleKey(Math?.ceil(Math?.random() * 20));
  }, []);

  const getSelectedChallengeId = () => {
    return selectedChallengeId || false;
  };

  const handleFeedback = () => {
    const selectedChallengeId = getSelectedChallengeId();

    const selectedChallenge =
      playerChallengeData && selectedChallengeId
        ? playerChallengeData[selectedChallengeId]
        : {};
    navigationRef.navigate('QuestionFeedback', {
      challenge: selectedChallenge,
      type: 'Player',
    });
  };

  const handleDone = () => {
    navigationRef.goBack(null);
  };

  selectedChallengeId = selectedChallengeId || false;

  const selectedChallenge =
    (playerChallengeData &&
      selectedChallengeId &&
      playerChallengeData[selectedChallengeId]) ||
    {};
  const {
    pointsEarned,
    pointsPossible,
    answers,
    task,
    guess,
    completionId,
    character,
    firstName,
  } = selectedChallenge;

  let formattedAnswers = [];
  let correctAnswer = '';

  if (answers) {
    formattedAnswers = answers.split('|')?.map?.((answer) => {
      let split = answer.split(':');
      if (split[1] == 'true') {
        correctAnswer = split[0];
      }
      return {text: split[0], correct: split[1] == 'true'};
    });
  }

  const paddingTop = Platform.OS == 'android' ? 0 : isX ? 55 : 20;

  // extracting the character

  const characterData = characters[character] || {};
  const imageSource = characterData?.source;

  return (
    <SafeAreaView style={{flex: 1, paddingTop}}>
      <View
        style={{alignItems: 'center', backgroundColor: global?.color?.white}}>
        <View style={{height: 130, width: 150, alignItems: 'center'}}>
          <FastImage
            source={{uri: imageSource}}
            style={{flex: 1, width: 130, marginVertical: 5}}
            resizeMode={FastImage?.resizeMode?.contain}
          />
          <BodyText text={firstName} textStyle={{fontWeight: '700'}} />
        </View>
      </View>
      <View style={{flex: 1, backgroundColor: 'white'}}>
        <BodyText
          text={task}
          textStyle={{
            marginTop: 20,
            marginBottom: 10,
            paddingLeft: 0,
            textAlign: 'center',
          }}
        />
        {!guess &&
          SeededShuffle.shuffle(formattedAnswers, shuffleKey, true)?.map?.(
            (answer, index) => {
              return (
                <PrimaryButton
                  key={`completed_challenge_${index}`}
                  text={answer.text}
                  buttonStyle={{
                    maxHeight: 50,
                    marginLeft: 20,
                    marginRight: 20,
                    backgroundColor: global?.color?.gray2,
                  }}
                  handlePress={() => {
                    triviaCompletionEvent(
                      {
                        correct: answer.correct,
                        option: answer.text,
                        completionId: completionId,
                        pointsPossible: parseInt(pointsPossible),
                        correctAnswer,
                      },
                      groupId,
                      false,
                    );
                  }}
                />
              );
            },
          )}
        {!!guess && (
          <View style={{flex: 1}}>
            <PrimaryButton
              text={guess}
              buttonStyle={{
                maxHeight: 50,
                marginLeft: 20,
                marginRight: 20,
                backgroundColor: pointsEarned ? 'green' : 'red',
              }}
              handlePress={() => null}
            />
            <BodyText
              text={
                pointsEarned
                  ? 'You got it right! You earned ' + pointsEarned + ' points!'
                  : 'Sorry, the correct answer was: ' + correctAnswer
              }
              textStyle={{
                marginTop: 10,
                marginBottom: 10,
                paddingLeft: 0,
                textAlign: 'center',
              }}
            />
            <View
              style={{
                width,
                height: 52,
                flexDirection: 'row',
                justifyContent: 'center',
              }}>
              <ImageButton
                buttonStyle={{elevation: 1}}
                imageStyle={{width: 175, height: 52, left: 10}}
                source={require('src/Images/shareButton.png')}
                handlePress={() => {
                  const shareObject = selectedChallenge;
                  const shareOrigin = 'Trivia';
                  const huntType = 'scavaHunt';

                  socialShare(shareObject, shareOrigin, huntType);
                }}
              />
              <ImageButton
                buttonStyle={{elevation: 1}}
                imageStyle={{width: 175, height: 52, left: -10}}
                source={require('src/Images/doneButton.png')}
                handlePress={() => handleDone()}
              />
            </View>
            <ImageButton
              buttonStyle={{elevation: 1}}
              imageStyle={{
                width: 50,
                height: 50,
                marginLeft: width / 2 - 30,
                marginTop: 10,
              }}
              source={require('src/Images/feedbackIcon.png')}
              handlePress={() => handleFeedback()}
            />
          </View>
        )}
      </View>
    </SafeAreaView>
  );
};

export default PlayerTrivia;
